import { render, staticRenderFns } from "./group-table.html?vue&type=template&id=25537222&scoped=true&external"
import script from "./group-table.js?vue&type=script&lang=js&external"
export * from "./group-table.js?vue&type=script&lang=js&external"
import style0 from "./group-table.scss?vue&type=style&index=0&id=25537222&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25537222",
  null
  
)

export default component.exports